import axios from '../utils/aioxs'

// 获取科中云单点登录code
export function getKZYLoginCode() {
  return axios({
    method: 'post',
    url: `/vpp/code`,
  })
}

// 电池检测列表
export function getBillList(domain_id, station_id, start_time, end_time) {
  const query =
    start_time && end_time ? `?start_time=${encodeURIComponent(start_time)}&end_time=${encodeURIComponent(end_time)}` : ''
  return axios({
    method: 'get',
    url: `/bill/${domain_id}/${station_id}/billlist${query}`,
  })
}

// 启动/停止健康检测
export function batteryHealthAction(domain_id, bill_number, action) {
  return axios({
    method: 'post',
    url: `/bill/${domain_id}/${bill_number}/batteryhealth/${action}`,
  })
}

// 订单详情（返回格式待定）
export function getBillDetail(domain_id, station_id, bill_number) {
  return axios({
    method: 'get',
    url: `/bill/${domain_id}/${station_id}/${bill_number}/detail`,
  })
}
